const c = {
  name: "Ssh",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M6.2,5c0,0.7-0.6,1.2-1.2,1.2C4.3,6.3,3.7,5.7,3.7,5c0-0.7,0.6-1.2,1.2-1.2C5.7,3.8,6.2,4.3,6.2,5z"/>
		<path class="st0" d="M10.3,5c0,0.7-0.6,1.2-1.3,1.2C8.3,6.3,7.7,5.7,7.7,5c0-0.7,0.6-1.2,1.2-1.2C9.7,3.8,10.3,4.3,10.3,5z"/>
		<path class="st0" d="M13,6.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C11.8,5.7,12.3,6.3,13,6.3z"/>
		<path class="st0" d="M28,19v-6h-2v14h2v-6h4v6h2V13h-2v6H28z"/>
		<path class="st0" d="M19,15c-0.5,0-1,0.5-1,1v1.6c0,0.4,0.3,0.8,0.7,1l0,0l3.3,1.1c1.2,0.4,2.1,1.6,2.1,2.8V24c0,1.7-1.3,3-3,3h-2
			c-1.7,0-3-1.3-3-3v-1h2v1c0,0.5,0.5,1,1,1h2c0.5,0,1-0.5,1-1v-1.6c0-0.4-0.3-0.8-0.7-1l0,0l-3.3-1.1C16.8,20,16,18.8,16,17.5V16
			c0-1.7,1.3-3,3-3h2c1.7,0,3,1.3,3,3v1h-2v-1c0-0.5-0.5-1-1-1H19z"/>
		<path class="st0" d="M8,16c0-0.5,0.5-1,1-1h2c0.5,0,1,0.5,1,1v1h2v-1c0-1.7-1.3-3-3-3H9c-1.7,0-3,1.3-3,3v1.6
			c0,1.3,0.8,2.4,2.1,2.8l3.3,1.1l0,0c0.4,0.1,0.7,0.5,0.7,1V24c0,0.5-0.5,1-1,1H9c-0.5,0-1-0.5-1-1v-1H6v1c0,1.7,1.3,3,3,3h2
			c1.7,0,3-1.3,3-3v-1.6c0-1.3-0.8-2.4-2.1-2.8l-3.3-1.1l0,0C8.3,18.4,8,18,8,17.5V16z"/>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v34c0,1.7,1.3,3,3,3h34c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H3z M2,3c0-0.6,0.4-1,1-1h34
			c0.6,0,1,0.4,1,1v34c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V3z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Ssh
};
